<template>
  <div class="app">

  </div>
</template>

<script>


  export default {
    data() {
      return {}
    },
    created() {

    },
    mounted() {
      document.write('https://cop.luobobeidiao.cn/#/Login');
    },
    methods: {},
    computed: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/toLogin.vue